module.exports = __webpack_public_path__ + "media/payment_methods/card-7b84f7cc.svg";